export const POSITION = {
  IS_TOP: 'is-top',
  IS_BOTTOM: 'is-bottom',
  IS_LEFT: 'is-left',
  IS_RIGHT: 'is-right'
};

export const TYPE = {
  IS_WHITE: 'is-white',
  IS_BLACK: 'is-black',
  IS_LIGHT: 'is-light',
  IS_DARK: 'is-dark',
  IS_PRIMARY: 'is-primary',
  IS_INFO: 'is-info',
  IS_SUCCESS: 'is-success',
  IS_WARNING: 'is-warning',
  IS_DANGER: 'is-danger'
};

export const SIZE = {
  IS_SMALL: 'is-small',
  IS_MEDIUM: 'is-medium',
  IS_LARGE: 'is-large'
};
